import { SearchFilters } from "@outschool/gql-frontend-generated";
import { useTranslation } from "@outschool/localization";
import React from "react";
import { Trans } from "react-i18next";

import { ConciergeInPageSection } from "./ConciergeInPageSection";
import { CONCIERGE_IN_PAGE_SECTION_USAGE } from "./constants";

export const CONCIERGE_IN_PAGE_SEARCH_PAGE_RESULT_TYPE = {
  SHOW_MORE: "showMore",
  TOO_SPECIFIC: "tooSpecific"
} as const;

export function ConciergeInPageSearchPage({
  resultType,
  searchFilters
}: {
  resultType: (typeof CONCIERGE_IN_PAGE_SEARCH_PAGE_RESULT_TYPE)[keyof typeof CONCIERGE_IN_PAGE_SEARCH_PAGE_RESULT_TYPE];
  searchFilters?: SearchFilters;
}) {
  const { t } = useTranslation(
    "client\\components\\concierge\\ConciergeInPageSearchPage"
  );
  const transText = (
    <Trans t={t}>
      It looks like we don’t have a perfect match just yet. Our Concierge team
      can recommend options for your learner. Share details like their schedule,
      interests, or goals, and we’ll send suggestions within{" "}
      <strong>2 business days</strong>.
    </Trans>
  );

  return (
    <ConciergeInPageSection
      usage={
        resultType === "showMore"
          ? CONCIERGE_IN_PAGE_SECTION_USAGE.SEARCH_PAGE_SHOW_MORE
          : CONCIERGE_IN_PAGE_SECTION_USAGE.SEARCH_PAGE_TOO_SPECIFIC
      }
      translatedDescription={transText}
      searchFilters={searchFilters}
    />
  );
}
